import { FinancedAmountStore, SelectedPlanStore } from '@servicetitan/financing-plans-shared';
import { formatCurrency, DataItem } from '@servicetitan/financing-utils-shared';
import { Card, Grid, Text } from '@servicetitan/anvil2';

export const FinancingDetails = () => {
    const { financedAmount } = FinancedAmountStore.useStore();
    const { selectedPlan } = SelectedPlanStore.useStore();
    const monthlyPayment =
        selectedPlan?.hasPromo && selectedPlan.promotionalMonthlyPayment !== undefined
            ? selectedPlan.promotionalMonthlyPayment
            : selectedPlan?.defaultMonthlyPayment;

    return (
        <Card
            flexDirection="column"
            gap="3"
            style={{ padding: '24px', width: '100%' }}
            alignSelf="center"
            role="listitem"
        >
            <Text variant="headline" el="h2" size="medium">
                Financing Details
            </Text>
            <Grid rowGap="5" templateColumns="repeat(auto-fit, minmax(265px, 1fr))">
                <DataItem
                    label="Desired Financed Amount"
                    text={formatCurrency(financedAmount ?? 0)}
                />
                <DataItem label="Estimated Payment" text={formatCurrency(monthlyPayment ?? 0)} />
                <DataItem label="Plan" text={selectedPlan?.description} />
            </Grid>
        </Card>
    );
};
